import httpClient from "@/api/config/httpClient";
import {
	CreateCustomerHandoverProcessFileDto,
	CustomerHandoverProcessDto,
	PatchCustomerHandoverProcessDto,
	SendCustomerHandoverProcessConfirmationDto,
	UpdateCustomerHandoverProcessFileDto
} from "../models/customer/customerHandover.model";
import { CommonUtil } from "@/utils/common.util";

export abstract class HandoverService {
	private static readonly CUSTOMER_URL = "/sys03/customer";
	private static readonly ADDITIONAL_CONTACTS = "additional-contacts";
	private static readonly RESEGMENTATIONS = "resegmentations";
	private static readonly HANDOVERS = "handovers";
	private static readonly FILES = "files";

	public static getCustomerHandoverById(customerId: string) {
		const url = `${HandoverService.CUSTOMER_URL}/${customerId}/handover`;
		return httpClient.get(url);
	}

	public static validateCustomerResegmentation(customerId: string) {
		const url = `${HandoverService.CUSTOMER_URL}/${customerId}/${HandoverService.RESEGMENTATIONS}/validate`;
		return httpClient.get(url);
	}

	public static createCustomerResegmentation(customerId: string) {
		const url = `${HandoverService.CUSTOMER_URL}/${customerId}/${HandoverService.RESEGMENTATIONS}`;
		return httpClient.post<CustomerHandoverProcessDto>(url);
	}

	public static sendCustomerResegmentation(id: number, data: PatchCustomerHandoverProcessDto) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.RESEGMENTATIONS}/${id}/send`;
		return httpClient.put(url, data);
	}

	public static sendCustomerResegmentationConfirmation(id: number, data: SendCustomerHandoverProcessConfirmationDto) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.RESEGMENTATIONS}/${id}/send-confirmation`;
		return httpClient.put(url, data);
	}

	public static continueCustomerResegmentation(id: number) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.RESEGMENTATIONS}/${id}/continue`;
		return httpClient.put(url);
	}

	public static getAdditionalContacts(processId: string) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.HANDOVERS}/${processId}/${HandoverService.ADDITIONAL_CONTACTS}`;
		return httpClient.get(url);
	}

	public static postAdditionalContact(additionalContact: any) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.HANDOVERS}/${HandoverService.ADDITIONAL_CONTACTS}`;
		return httpClient.post(url, additionalContact);
	}

	public static putAdditionalContact(additionalContact: any) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.HANDOVERS}/${HandoverService.ADDITIONAL_CONTACTS}/${additionalContact.id}`;
		return httpClient.put(url, additionalContact);
	}

	public static deleteAdditionalContact(additionalContactId: string) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.HANDOVERS}/${HandoverService.ADDITIONAL_CONTACTS}/${additionalContactId}`;
		return httpClient.delete(url);
	}

	public static getDocuments({ id }: { id: number }) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.HANDOVERS}/${id}/${HandoverService.FILES}`;
		return httpClient.get(url);
	}

	public static downloadDocument({ id }: { id: number }) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.HANDOVERS}/${HandoverService.FILES}/${id}/download`;
		return httpClient.get(url, { responseType: "blob" });
	}

	public static createDocument({ customerHandoverFile }: { customerHandoverFile: CreateCustomerHandoverProcessFileDto }) {
		const { customerHandoverProcessId: cusotmerHandoverProcessId, fileName, file, type, comment } = customerHandoverFile;

		const formData = new FormData();
		formData.append("customerHandoverProcessId", String(cusotmerHandoverProcessId));
		formData.append("fileName", fileName);
		formData.append("file", file);
		formData.append("type", type);
		if (comment) {
			formData.append("comment", comment);
		}
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.HANDOVERS}/${HandoverService.FILES}`;
		return httpClient.post(url, formData, {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		});
	}

	public static updateDocument({ id, customerHandoverFile }: { id: number; customerHandoverFile: UpdateCustomerHandoverProcessFileDto }) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.HANDOVERS}/${HandoverService.FILES}/${id}`;
		const payload = CommonUtil.clearObjectEmptyStrings({ obj: customerHandoverFile });

		return httpClient.put(url, payload);
	}

	public static deleteDocument({ id }: { id: number }) {
		const url = `${HandoverService.CUSTOMER_URL}/${HandoverService.HANDOVERS}/${HandoverService.FILES}/${id}`;
		return httpClient.delete(url);
	}
}
